import { Header, Paragraph } from "@datagame/ui";
import classNames from "classnames/bind";

import styles from "./ReportBadge.module.scss";

const cx = classNames.bind(styles);

export interface ReportBadgeProps {
  header: string;
  count: number;
  variant?: "primary" | "blue";
}

export const ReportBadge = ({ header, count, variant = "primary" }: ReportBadgeProps) => {
  return (
    <div className={styles.badge}>
      <div className={styles.badgeHeader}>
        <div className={cx("seperator", variant)}></div>
        <Paragraph color="secondary" weight="font-bold">
          {header}
        </Paragraph>
      </div>
      <Header variant="h2">{count}</Header>
    </div>
  );
};
